const hasSufficientSavingsAmount = (
  savingsAmount: number,
  threshold?: number
) => {
  return savingsAmount > (threshold ?? 0);
};

export default hasSufficientSavingsAmount;
